(function () {
    'use strict';
    angular.module('ib-pmt-subscription-models-confirmation-module')
        .component('ibSubscriptionModelsConfirmation', {
            controller: 'SubscriptionModelsConfirmationController',
            controllerAs: 'confirmationCtrl',
            bindings: {
            },
            templateUrl: ['$rootScope', function ($rootScope) {
                return $rootScope.routes.templates + 'ib-pmt-gift-cards-confirmation-view.html';
            }]
        });

})();